import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import authenticationSlice from '@/state/authentication.slice';
import { Event, Profile } from '@bimdata/definitions/dto';
import { invitations as projectInvitations } from '@/api/project';
import { list as userInvitations } from '@/api/invitation';

export default async function (event: Event, profile: Profile) {
  const { participantId, projectCode, invitationId } = event.data;
  if (participantId === profile.id) {
    const invitation = await userInvitations().then((list) => (
      list.find((inv) => inv.id === invitationId)
    ));
    if (invitation) {
      store.dispatch(authenticationSlice.actions.addInvitation(invitation));
    }
  } else {
    const invitation = await projectInvitations(projectCode).then((list) => (
      list.find((inv) => inv.id === invitationId)
    ));
    if (invitation) {
      store.dispatch(
        projectSlice.actions.addInvitation({
          code: projectCode,
          invitation: {
            id: invitation.id,
            access: invitation.project.access,
            participant: invitation.participant
          },
        })
      );
    }
  }
};
